(function () {
  function initMegaMenus(root) {
    (root || document).querySelectorAll('.lukzer-header-nav__item--mega').forEach(function (mega) {
      if (mega.dataset.megaReady === 'true') return;
      mega.dataset.megaReady = 'true';

      var trigger = mega.querySelector('.lukzer-header-nav__mega-trigger');
      var menu = mega.querySelector('.lukzer-mega-menu');
      var closeTimer;

      if (menu.parentNode !== document.body) {
        document.querySelectorAll('body > .lukzer-mega-menu[data-mega-section="' + menu.dataset.megaSection + '"]').forEach(function (oldMenu) {
          if (oldMenu !== menu) oldMenu.remove();
        });
        document.body.appendChild(menu);
      }

      function centerMenu() {
        menu.style.left = (document.documentElement.clientWidth / 2) + 'px';
      }

      function setOpen(open) {
        window.clearTimeout(closeTimer);
        if (open) centerMenu();
        mega.classList.toggle('is-open', open);
        menu.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      }

      trigger.addEventListener('click', function () {
        setOpen(!mega.classList.contains('is-open'));
      });
      mega.addEventListener('mouseenter', function () { setOpen(true); });
      mega.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(function () { setOpen(false); }, 180);
      });
      menu.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        setOpen(true);
      });
      menu.addEventListener('mouseleave', function () {
        closeTimer = window.setTimeout(function () { setOpen(false); }, 120);
      });
      mega.addEventListener('focusin', function () { setOpen(true); });
      mega.addEventListener('focusout', function (event) {
        if (!mega.contains(event.relatedTarget) && !menu.contains(event.relatedTarget)) setOpen(false);
      });
      menu.addEventListener('focusout', function (event) {
        if (!mega.contains(event.relatedTarget) && !menu.contains(event.relatedTarget)) setOpen(false);
      });
      document.addEventListener('click', function (event) {
        if (!mega.contains(event.target) && !menu.contains(event.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && mega.classList.contains('is-open')) {
          setOpen(false);
          trigger.focus();
        }
      });
      window.addEventListener('resize', centerMenu, { passive: true });
      window.addEventListener('orientationchange', centerMenu, { passive: true });
      centerMenu();
    });
  }

  function bindMobileAccordion() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.lukzer-mobile-mega__trigger');
      if (!trigger) return;

      var item = trigger.closest('.lukzer-mobile-mega__item');
      var accordion = trigger.closest('.lukzer-mobile-mega');
      var willOpen = !item.classList.contains('is-open');

      accordion.querySelectorAll('.lukzer-mobile-mega__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        openItem.querySelector('.lukzer-mobile-mega__trigger').setAttribute('aria-expanded', 'false');
      });

      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  }

  function bindMobileClose() {
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.lukzer-mobile-menu__close')) return;
      var menuButton = document.querySelector('#show-megamenu');
      if (menuButton && menuButton.classList.contains('act')) menuButton.click();
    });
  }

  function init() {
    initMegaMenus(document);
    bindMobileAccordion();
    bindMobileClose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initMegaMenus(event.target);
  });
})();
